export class FlightCreate {
    public id: number;
    public passenger_id: number;
    public ticket_no: number;
    public pnr: string;

    constructor(passenger_id: number, ticket_no: number, pnr: string) {
        this.passenger_id = passenger_id;
        this.ticket_no = ticket_no;
        this.pnr = pnr;
    }
}

export class Flight {
    public id: number;
    public passenger_id: number;
    public ticket_no: number;
    public pnr: string;

    constructor(id: number, passenger_id: number, ticket_no: number, pnr: string) {
        this.id = id;
        this.passenger_id = passenger_id;
        this.ticket_no = ticket_no;
        this.pnr = pnr;
    }
}

export class FlightUpdate {
    public id: number;
    public passenger_id: number;
    public ticket_no: string;
    public pnr: string;
    constructor(id: number, passenger_id: number, ticket_no: string, pnr: string) {
        this.id = id;
        this.passenger_id = passenger_id;
        this.ticket_no = ticket_no;
        this.pnr = pnr;
    }
}
